var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H42C49.732 0 56 6.26801 56 14V42C56 49.732 49.732 56 42 56H14C6.26801 56 0 49.732 0 42V14Z",
    fill: "url(#paint0_linear_1_2994)",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 39.3516C27.188 39.5564 27.5904 39.6642 28 39.6642C28.4096 39.6642 28.812 39.5564 29.1667 39.3516L37.3333 34.685C37.6877 34.4804 37.982 34.1862 38.1868 33.8319C38.3916 33.4777 38.4996 33.0758 38.5 32.6666V23.3333C38.4996 22.9241 38.3916 22.5222 38.1868 22.168C37.982 21.8137 37.6877 21.5196 37.3333 21.315L29.1667 16.6483C28.812 16.4435 28.4096 16.3357 28 16.3357C27.5904 16.3357 27.188 16.4435 26.8333 16.6483L18.6667 21.315C18.3123 21.5196 18.018 21.8137 17.8132 22.168C17.6084 22.5222 17.5004 22.9241 17.5 23.3333V32.6666C17.5004 33.0758 17.6084 33.4777 17.8132 33.8319C18.018 34.1862 18.3123 34.4804 18.6667 34.685L26.8333 39.3516Z",
    stroke: "#0EA59D",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39.6667V28",
    stroke: "#0EA59D",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8359 22.166L27.9976 27.9993L38.1593 22.166",
    stroke: "#0EA59D",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18.9824L33.25 24.9908",
    stroke: "#0EA59D",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2994",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA59D",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9088"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.aa3189a01257664ccbce1982f89c7f01.svg";
export { ForwardRef as ReactComponent };